import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quizAlertModal: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setQuizAlertModal(state, action) {
      state.quizAlertModal = action.payload;
    },

    clearSelectedState(state) {
      state.quizAlertModal = false;
    },
  },
});

export const {
  setQuizAlertModal,
  clearSelectedState,
} = modalSlice.actions;

export default modalSlice.reducer;
